/*
*
* Home Component
*
*/
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import library_logo from './images/library_logo.png';
import bookmarks from './images/bookmark fan_021126.png';
import bysLogo from './images/bys_logo_vert.svg';
import my529LogoWithTagline from './images/my529_logo_Utah_tagline.jpg';
import { Button } from '@mui/material';
import { DATE_FORMAT, DATES, PHASES, DATE_FORMAT_NO_YEAR } from 'components/AppRoot/Navigation/constants';
import dayjs from 'dayjs';

import './styles.css';

const select = (state) => ({
  currentPhase: state.params.currentPhase,
  contestDates: state.params.contestDates,
  winners: state.params.winners,
});

export class Home extends React.Component {
  static propTypes = {
    currentPhase: PropTypes.string.isRequired,
    contestDates: PropTypes.object.isRequired,
    winners: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      libraryName: PropTypes.string,
      libraryRegion: PropTypes.number,
    })),
  };

  textGenerate = () => {
    const {
      currentPhase,
      contestDates,
      winners,
    } = this.props;

    switch (currentPhase) {
      case PHASES.Teaser:
        return [
          <h1 key='startDate'>Going live {dayjs(contestDates[DATES.StartDate]).format(DATE_FORMAT)}</h1>,
          <p key='p1'><b>Six $2,000 scholarship opportunities</b> for Utah children.</p>
        ];

      case PHASES.Start:
        return [
          <div key='signUpButton' className='Home_button'>
            <Button
              color='primary'
              onClick={() => this.props.history.push('/signup')}
              variant='contained'
              style={{ width: '250px' }}
            >
              Sign up here
            </Button>
          </div>,
          <p key='p1'>Register for the summer reading program at your local library. Then enter for a chance at one of <b>six</b> regional <strong style={{ color: 'var(--accent)' }}>$2,000</strong> my529 scholarships.</p>,
          <p key='p2'>One entry per reader, age 18 and under (born on or after {dayjs(contestDates.birthDate).format(DATE_FORMAT)}). <b>No purchase necessary to enter.</b></p>,
          <p key='p3'>Book Your Summer runs {dayjs(contestDates[DATES.StartDate]).format(DATE_FORMAT)}, through {dayjs(contestDates[DATES.EndDate]).format(DATE_FORMAT_NO_YEAR)}.</p>,
        ];

      case PHASES.End:
        return [
          <p key='p1'>Thank you for your participation. Book Your Summer is now closed. Please check back next month for a list of the winners.</p>
        ];

      case PHASES.Winner:
        return [
          <h1 key='congratulations' style={{ textAlign: 'center' }}>Congratulations!</h1>,
          <div key='winners' className='Home_winners'>
            {winners.map(winner => (
              <span key={winner.name}>
                <strong>{winner.name}</strong> - {winner.libraryName}
                <small> (Region {winner.libraryRegion})</small>
              </span>
            ))}
          </div>,
          <p key='visitAgain' style={{ textAlign: 'center' }}>Visit us again in May {contestDates.visitYear}!</p>
        ];

      default: return '';

    }
  }

  render() {
    return (
      <div className='Home_container'>
        <div className='Home_main'>
          <img src={bookmarks} alt='Bookmarks' className='Home_bookmarksImg' />
          <img src={bysLogo} alt='Book Your Summer' className='Home_bysLogoImg' />
        </div>

        <div className='Home_text'>
          {this.textGenerate()}
        </div>
        <div className='Home_logos'>
          <a href='https://library.utah.gov' target='_blank' rel='noopener noreferrer'>
            <img src={library_logo} alt='Utah State Library' />
          </a>
          <a href='https://my529.org' target='_blank' rel='noopener noreferrer'>
            <img src={my529LogoWithTagline} alt='my529' />
          </a>
        </div>
      </div>
    );
  }
}

export default connect(select, {})(Home);